/**
 * Created by Mark on 06/04/2017.
 */

import React  from 'react';
import DataTableComponent from '../tables/table.component.js';
import { FormattedMessage } from 'react-intl';

import StudentsService from '../../services/student-services.js';
import StudentsStore from '../../store/student-store.js';

export default class StudentTableComponent extends React.Component {


    constructor(props){
        super();
        this.props = props;
        this.state = {
            students:[],
            handleEdit:this.props.handleEdit || false,
            handleDelete:this.props.handleDelete
        }
    }


    componentDidMount() {
        StudentsService.getAllViewableStudents();
    }

    componentWillMount(){
        StudentsStore.on("CHANGE" , () => {
            this.setState({
                students:StudentsStore.allMyStudents
            });
        });
    }

    rebuildSchema(dataObject) {


        const schema = {
            type: 'object',
            properties: {
                profileLink: {
                    type: 'link',
                    translationsID: 'ui-14',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Name',
                    id: 'profileLink'
                },
                username: {
                    type: 'string',
                    translationsID: 'ui-22',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Username',
                    id: 'username'
                },
                password: {
                    type: 'string',
                    translationsID: 'ui-23',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Password',
                    id: 'password'
                },
                classes: {
                    type: 'group',
                    translationsID: 'ui-320',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Class',
                    className:'hidden-xs',
                    id: 'classesLinks'
                },
                lastLogin: {
                    type: 'string',
                    translationsID: 'ui-13',
                    modifable: false,
                    display: true,
                    defaultMessage: 'Name',
                    id: 'lastLogin'
                },

            },
            data: this.state.students
        };


        return schema;
    }

    handelTransferStudents(){
        return window.location.href = "#/student/deleted";
    }

    getAdditionalControls(){


        return [
           {action:this.handelTransferStudents.bind(this), icon:'zmdi zmdi-delete zmdi-hc-fw' , text: <FormattedMessage id={ 'ui-587' } defaultMessage={ 'Deleted Students' }/>},
        ]
    }

    render(){
        return <DataTableComponent strictSearch additionalButtons={this.getAdditionalControls()} strictSearch={true} rowLimit={20} editaction={this.state.handleEdit} deleteaction={this.state.handleDelete}  schema={this.rebuildSchema([])} ref={(object) => { this.table = object; } }  />

    }
}


// WEBPACK FOOTER //
// ./src/components/tables/students-table.js